const detectExpenseType = (expense) => {
    const specificData = expense.donnees_specifiques || {};

    if (specificData.nom_hotel || specificData.date_arrivee_hotel) return 'hotel';
    if (specificData.lieu_depart_avion || specificData.lieu_arrivee_avion) return 'plane';
    if (specificData.nom_restaurant || specificData.nb_invites) return 'restaurant';
    if (specificData.lieu_depart_taxi || specificData.destination_taxi) return 'taxi';
    if (specificData.litres) return 'carburant';
    if (specificData.societe_location) return 'carRental';
    if (specificData.distance_parcourue) return 'distance_km';

    return 'other';
  };

export { detectExpenseType };